<template>
    <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <template v-for="(item,i) in crumbs">
                <el-breadcrumb-item :key="i" v-if="showWater">{{item.name}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: item.path }" :key="i" v-else>{{item.name}}</el-breadcrumb-item>
            </template>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    name: "crumbs",
    props:['arr','showWater'],
    computed:{
        crumbs(){
            return this.arr || []
        }
    }
}
</script>

<style scoped lang="scss">
.crumbs{
    /deep/.el-breadcrumb{line-height: 40px;font-size: 12px;width: 1180px;    margin: 0 auto;
        .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{font-weight: normal;color:#262626;}
        .el-breadcrumb__inner a:hover,.el-breadcrumb__inner.is-link:hover{color:#329d15;cursor: pointer;}
    }
}
</style>